/**
 * Static switches for the landing, flipped in code and shipped with a deploy. `showPricing` shows the plans section, its nav
 * link and the FAQ's plan question (off until pricing is settled). `radarPicker` lets the hero radar's legend wheels be
 * turned by hand; `radarVariant` picks the demo it tells. `solutionsVariant` picks how a Solutions card is entered.
 */
export const FEATURE_FLAGS: {
  showPricing: boolean
  radarPicker: boolean
  radarVariant: 'team' | 'simple'
  solutionsVariant: 'card' | 'link'
} = {
  showPricing: false,
  // The radar's legend wheels can be turned by the visitor; off, they only show the current selection.
  radarPicker: false,
  // Which demo the hero radar tells: a team and all its members with a legend, or just the radar moving between a team
  // and one member.
  radarVariant: 'simple',
  // How a Solutions card is entered: the whole card is the link, or it carries a call to action under its copy.
  solutionsVariant: 'card',
}
